import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { SiteProvider } from "@/context/SiteContext";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import { Layout } from "@/components/site/Layout";
import Home from "@/pages/Home";
import Donate from "@/pages/Donate";
import Support from "@/pages/Support";
import PoetryClub from "@/pages/PoetryClub";
import DefStreet from "@/pages/DefStreet";
import Community from "@/pages/Community";
import Impact from "@/pages/Impact";
import PaymentResult from "@/pages/PaymentResult";
import { SignInPage, SignUpPage } from "@/pages/AuthPages";
import AdminApp from "@/admin/AdminApp";

const ClerkLayout = () => (
  <ClerkAuthProvider>
    <Outlet />
  </ClerkAuthProvider>
);

function App() {
  return (
    <SiteProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/donate" element={<Donate />} />
            <Route path="/support" element={<Support />} />
            <Route path="/poetry-club" element={<PoetryClub />} />
            <Route path="/def-street" element={<DefStreet />} />
            <Route path="/community" element={<Community />} />
            <Route path="/impact" element={<Impact />} />
            <Route path="/payment/:result" element={<PaymentResult />} />
          </Route>
          <Route element={<ClerkLayout />}>
            <Route path="/sign-in/*" element={<SignInPage />} />
            <Route path="/sign-up/*" element={<SignUpPage />} />
            <Route path="/admin/*" element={<AdminApp />} />
          </Route>
        </Routes>
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </SiteProvider>
  );
}

export default App;
